<template>
  <div class="bq-product-zsjgl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="bq-intro">
      <InfoBox
        :itemObj="item"
        :col="4"
        v-for="item in proIntros"
        :key="item.advTitles"
        :classes="'intro'"
      ></InfoBox>
    </div>
    <div class="container-div">
      <div class="container">
        <div class="left-mark"></div>
        <div class="line-content">
          <p>
            主数据管理主要用于对医院信息化系统中通用的字典进行标准化的定义，如诊断、手术、收费项目、科室等，从而实现通用字典表的统一管理。主数据标准化管理，可以实现医院不同业务系统之间使用同一套业务标准，促进数据的互联互通。具体功能包括：基础
            字典管理、术语管理、字典同步更新等。
          </p>
        </div>
        <div class="right-mark"></div>
      </div>
      <div class="area-wrap">
        <div class="area">
          <div class="area-title">
            主数据管理平台
          </div>
          <div class="area-content">
            <div
              class="content-item"
              v-for="(frameItem, index) in frameList"
              :key="index"
            >
              <div class="content-item-title">
                {{ frameItem.title }}
              </div>
              <div class="content-item-desc">
                <div
                  class="item-title"
                  v-for="(desc, idx) in frameItem.descList"
                  :key="idx"
                >
                  {{ desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div
      class="bq-advantage"
      v-for="(itemList, idx) in advantageList"
      :key="idx"
    >
      <InfoBox
        :itemObj="item"
        :col="2"
        v-for="item in itemList"
        :key="item.advTitles"
        :classes="'advantage'"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zsjgl',
  data() {
    return {
      proIntros: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1O9I5DNz1gK0jSZSgXXavwpXa-70-88.png',
          advTitles: '管理',
          advDesc: '主要管理医疗基础数据及建立规范的数据应用标准',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1NZt8F4z1gK0jSZSgXXavwpXa-82-92.png',
          advTitles: '建立',
          advDesc: '建立一套健康信息化标准体系',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1Qs7.DQT2gK0jSZFkXXcIQFXa-80-80.png',
          advTitles: '改善',
          advDesc: '从根本上改善和解决医疗系统之间的数据标准问题',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1LJc_DHY1gK0jSZTEXXXDQVXa-86-88.png',
          advTitles: '促进',
          advDesc:
            '确保整个区域或医疗机构数据使用同一套数据标准，促进数据的互认互通',
        },
      ],
      frameList: [
        {
          title: '映射管理',
          descList: ['主数据映射', '值域映射', '映射系统管理'],
        },
        {
          title: '数据集管理',
          descList: ['数据集管理', 'OID管理'],
        },
        {
          title: '值域字典',
          descList: ['国家标准', '卫生标准', '卫生扩展标准'],
        },
        {
          title: '医疗字典',
          descList: [
            '药品目录',
            '收费目录',
            '医用材料',
            '疾病编码',
            '手术操作分类与代码',
          ],
        },
        {
          title: '基础主数据',
          descList: ['机构管理', '医护人员管理', '科室管理', '医疗组管理'],
        },
      ],
      advantageList: [
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1K7q3DpT7gK0jSZFpXXaTkpXa-84-90.png',
            advTitles: '全面的值域标准',
            advDesc:
              '平台覆盖国家标准、卫生标准及卫生扩展标准，支持标准增、删、改、查、发布等操作，满足不同业务场景',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1oLe7DAL0gK0jSZFxXXXWHVXa-86-84.png',
            advTitles: '统一基础主数据',
            advDesc:
              '对区域或医院基础数据进行统一管理，一处更新，处处更新，确保数据来源的唯一性和准确性',
          },
        ],
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1m9u6DAY2gK0jSZFgXXc5OFXa-82-76.png',
            advTitles: '全面的医疗字典',
            advDesc:
              '覆盖基础医疗字典，确保各系统应用同一套标准，确保数据规范有效',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB13Lu6DET1gK0jSZFhXXaAtVXa-84-84.png',
            advTitles: '先进的映射管理',
            advDesc:
              '平台提供主数据和值域映射功能，确保数据标准统一，应用标准统一',
          },
        ],
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
@import './zsjgl.less';
</style>
